export default "__VITE_ASSET__$LPWIWF0__"